var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEediEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157px",
    height: "109px",
    viewBox: "0 0 157 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.490808661,27.6863607 C0.77204358,33.1099273 0.0111008992,38.6884959 1.33451342,43.9570605 C7.36800628,67.9766663 34.341266,80.1858541 53.8785708,63.1292529 C64.0907764,54.2137181 56.2661257,32.4220681 70.7966976,28.3353788 C75.7823608,26.9331727 80.7660337,29.1932432 83.3258553,33.8965731 C90.4347119,46.9581465 93.2268989,79.275996 116.329767,73.4258754 C119.863962,72.5309449 123.593757,71.3209494 126.24969,68.8332594 C129.958954,65.3589627 137.138628,40.1500335 143.661466,40.1500335",
    id: "Path-3",
    strokeOpacity: 0.5,
    stroke: "#4F5E71",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(13.567839, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    strokeOpacity: 0.1,
    stroke: "#4F5E71",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 116.58794,
    height: 51.5262369
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    strokeOpacity: 0.1,
    stroke: "#4F5E71",
    fill: "#F0F4F7",
    x: 0.5,
    y: 0.5,
    width: 116.58794,
    height: 11.7563718
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 5.25262369,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 20.2601199,
    width: 24.8743719,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#0067FF",
    x: 90.4522613,
    y: 37.5187406,
    width: 20.3517588,
    height: 6.0029985
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#F8EAA6",
    x: 90.4522613,
    y: 3.75187406,
    width: 20.3517588,
    height: 6.0029985
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 36.7683658,
    width: 18.0904523,
    height: 1.50074963
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#B8B8B8",
    x: 5.27638191,
    y: 40.5202399,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 35.4271357,
    y: 36.7683658,
    width: 18.0904523,
    height: 1.50074963
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#B8B8B8",
    x: 35.4271357,
    y: 40.5202399,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#0067FF",
    x: 5.27638191,
    y: 25.5127436,
    width: 24.8743719,
    height: 1.50074963
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 56.278111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    strokeOpacity: 0.1,
    stroke: "#4F5E71",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 116.58794,
    height: 51.5262369
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    strokeOpacity: 0.1,
    stroke: "#4F5E71",
    fill: "#F0F4F7",
    x: 0.5,
    y: 0.5,
    width: 116.58794,
    height: 11.7563718
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 5.25262369,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 20.2601199,
    width: 24.8743719,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#0067FF",
    x: 90.4522613,
    y: 37.5187406,
    width: 20.3517588,
    height: 6.0029985
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#9FEDC4",
    x: 90.4522613,
    y: 3.75187406,
    width: 20.3517588,
    height: 6.0029985
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 5.27638191,
    y: 36.7683658,
    width: 18.0904523,
    height: 1.50074963
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#B8B8B8",
    x: 5.27638191,
    y: 40.5202399,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#D8D8D8",
    x: 35.4271357,
    y: 36.7683658,
    width: 18.0904523,
    height: 1.50074963
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#B8B8B8",
    x: 35.4271357,
    y: 40.5202399,
    width: 12.8140704,
    height: 3.00149925
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#0067FF",
    x: 5.27638191,
    y: 25.5127436,
    width: 24.8743719,
    height: 1.50074963
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#A9B4C6",
    fillRule: "nonzero",
    opacity: 0.529631696,
    cx: 151.5,
    cy: 39.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.053711,38.2548828 C152.032552,38.250651 152.013509,38.2485352 151.996582,38.2485352 L151.939453,38.2485352 C151.778645,38.2485352 151.628419,38.2802731 151.48877,38.34375 C151.34912,38.4072269 151.221111,38.4908035 151.104736,38.5944824 C150.988362,38.6981613 150.884685,38.8155918 150.793701,38.9467773 C150.702718,39.0779629 150.621257,39.2080885 150.549316,39.3371582 C150.477376,39.4662279 150.417074,39.5900059 150.368408,39.7084961 C150.319743,39.8269863 150.282715,39.9264319 150.257324,40.0068359 C150.405437,39.9306637 150.558837,39.8439132 150.717529,39.746582 C150.876221,39.6492508 151.02539,39.5561528 151.165039,39.4672852 C151.304688,39.3784175 151.42635,39.2980147 151.530029,39.2260742 C151.633708,39.1541338 151.706706,39.1054689 151.749023,39.0800781 C151.939454,38.9615879 152.070638,38.8505051 152.142578,38.7468262 C152.214519,38.6431473 152.250488,38.553223 152.250488,38.4770508 C152.250488,38.4135739 152.230388,38.3627932 152.190186,38.324707 C152.149984,38.2866209 152.104492,38.2633464 152.053711,38.2548828 Z M152.282227,37.3789062 C152.633465,37.3789062 152.895832,37.4635408 153.069336,37.6328125 C153.242839,37.8020842 153.32959,38.0369451 153.32959,38.3374023 C153.32959,38.5151376 153.283041,38.7013337 153.189941,38.8959961 C153.096842,39.0906585 152.936036,39.2884918 152.70752,39.489502 C152.479003,39.6905121 152.17326,39.8957509 151.790283,40.1052246 C151.407306,40.3146983 150.928063,40.5252268 150.352539,40.7368164 C150.373698,40.8595384 150.43929,40.9558102 150.549316,41.0256348 C150.659343,41.0954593 150.805338,41.1303711 150.987305,41.1303711 C151.181967,41.1303711 151.39038,41.1018069 151.612549,41.0446777 C151.834718,40.9875485 152.054768,40.9145512 152.272705,40.8256836 C152.490642,40.736816 152.703287,40.6405441 152.910645,40.5368652 C153.118002,40.4331863 153.305256,40.3347986 153.472412,40.2416992 C153.639568,40.1485998 153.779215,40.068197 153.891357,40.0004883 C154.0035,39.9327796 154.078613,39.8904623 154.116699,39.8735352 C154.154785,39.8481444 154.189697,39.8333334 154.221436,39.8291016 C154.253174,39.8248698 154.281738,39.8227539 154.307129,39.8227539 C154.35791,39.8227539 154.400228,39.8343912 154.434082,39.857666 C154.467936,39.8809409 154.496501,39.9084471 154.519775,39.9401855 C154.54305,39.971924 154.558919,40.0057778 154.567383,40.041748 C154.575846,40.0777183 154.580078,40.1083983 154.580078,40.1337891 C154.580078,40.1718752 154.575846,40.2173663 154.567383,40.2702637 C154.558919,40.3231611 154.527181,40.3834632 154.472168,40.4511719 C154.451009,40.4723308 154.380128,40.5294592 154.259521,40.6225586 C154.138915,40.715658 153.983399,40.825683 153.792969,40.9526367 C153.602538,41.0795905 153.38143,41.2139479 153.129639,41.3557129 C152.877847,41.4974779 152.611248,41.6276036 152.329834,41.7460938 C152.04842,41.8645839 151.755373,41.9629716 151.450684,42.0412598 C151.145995,42.1195479 150.845542,42.1586914 150.549316,42.1586914 C150.295409,42.1586914 150.070069,42.1100265 149.873291,42.0126953 C149.676513,41.9153641 149.509359,41.7841805 149.371826,41.6191406 C149.234293,41.4541007 149.129558,41.263673 149.057617,41.0478516 C148.985677,40.8320302 148.949707,40.6056327 148.949707,40.3686523 C148.949707,40.1866853 148.985677,39.9867361 149.057617,39.7687988 C149.129558,39.5508615 149.233235,39.3318696 149.368652,39.1118164 C149.50407,38.8917632 149.670165,38.677003 149.866943,38.4675293 C150.063722,38.2580556 150.28483,38.0729175 150.530273,37.9121094 C150.775717,37.7513013 151.04549,37.6222336 151.3396,37.5249023 C151.633709,37.4275711 151.947915,37.3789062 152.282227,37.3789062 Z",
    id: "e",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEediEmpty);
export default __webpack_public_path__ + "static/media/eedi_empty.4cdf715400534581eea61403f24d33f2.svg";
export { ForwardRef as ReactComponent };